import * as React from "react";
import { SVGProps } from "react";
const SvgLogoCohere = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#logo-cohere_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.184 9.536c.427 0 1.28-.021 2.475-.512 1.387-.576 4.117-1.6 6.101-2.667 1.387-.746 1.985-1.728 1.985-3.05A3.31 3.31 0 0 0 12.438 0h-7.68A4.762 4.762 0 0 0 0 4.757c0 2.624 2.005 4.779 5.184 4.779Z"
        fill="#39594D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.485 12.8c0-1.28.768-2.453 1.963-2.944l2.41-1.002C13.313 7.85 16 9.643 16 12.288A3.715 3.715 0 0 1 12.288 16H9.664c-1.75 0-3.179-1.43-3.179-3.2Z"
        fill="#D18EE2"
      />
      <path
        d="M2.752 10.155A2.759 2.759 0 0 0 0 12.907v.363C0 14.763 1.237 16 2.752 16a2.759 2.759 0 0 0 2.752-2.752v-.362c-.021-1.494-1.237-2.731-2.752-2.731Z"
        fill="#FF7759"
      />
    </g>
    <defs>
      <clipPath id="logo-cohere_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoCohere;
